// extracted by mini-css-extract-plugin
export var bold = "_rw-0";